import { Menu } from "./menu.model";

export const menus = [
  {
    id: 1,
    href: null,
    icon: "home",
    parentId: 0,
    routerLink: "/main",
    target: null,
    title: "Dashboard",
  },
  {
    id: 2,
    href: null,
    icon: "people",
    parentId: 0,
    routerLink: "/main/admin",
    target: null,
    title: "User Management",
  },
  {
    id: 3,
    href: null,
    icon: "settings",
    parentId: 0,
    routerLink: "/main/administration",
    target: null,
    title: "Sytem Settings",
  },
  {
    id: 5,
    href: null,
    icon: "check_circle",
    parentId: 0,
    routerLink: "/main/group",
    target: null,
    hasSubMenu: true,
    title: "Group Registration",
  },
   {
    id: 8,
    href: null,
    icon: "check_circle",
    parentId: 5,
    routerLink: "/main/group",
    target: null,
    hasSubMenu: false,
    title: "Group Registration",
  },
  {
    id: 4,
    href: null,
    icon: "assignment",
    parentId: 5,
    routerLink: "/main/group/profile",
    target: null,
    hasSubMenu: false,
    title: "Group Profile",
  },
  {
    id: 5,
    href: null,
    icon: "people",
    parentId: 5,
    routerLink: "/main/group/members",
    target: null,
    hasSubMenu: false,
    title: "Group Members",
  },
  {
    id: 6,
    href: null,
    icon: "notifications",
    parentId: 5,
    routerLink: "/main/group/notification",
    target: null,
    hasSubMenu: false,
    title: "Notification",
  },
  {
    id: 10,
    href: null,
    icon: "folder",
    parentId: 0,
    routerLink: "/main/group-management",
    target: null,
    hasSubMenu: true,
    title: "Group Management",
  },
  {
    id: 11,
    href: null,
    icon: "list",
    parentId: 10,
    routerLink: "/main/group-management",
    target: null,
    hasSubMenu: false,
    title: "Group List",
  },
];

export const verticalMenuItems = [];

export const horizontalMenuItems = [];
